import { useState } from "react";
import { AudioStreamer } from "./AudioStreamer";

export const useAudioStreamer = (socket) => {
  const [isRecording, setIsRecording] = useState(false);
  const [listeningText, setListeningText] = useState("Listening...");

  const startStreaming = (config) => {
    setIsRecording(true);
    setListeningText("Listening...");
    AudioStreamer.startRecording(socket, config, setListeningText);
  };

  const stopStreaming = () => {
    setIsRecording(false);
    setListeningText("Listening...");
    AudioStreamer.stopRecording(socket);
  };

  return { startStreaming, stopStreaming, isRecording, listeningText };
};